import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';

@Component({
    selector: 'app-date-range',
    template: `
    @if (visible) {
      <mat-form-field class="example-form-field" [formGroup]="group" appearance="outline">
        <mat-label>{{ field.label }} </mat-label>
        <mat-date-range-input [rangePicker]="dateRangePicker">
          <input matStartDate (dateChange)="setStart($event)"
            [formControlName]="field.dateRangeFirstKey"
            [placeholder]="field.dateRangeFirstLabel" readonly>
          <input matEndDate (dateChange)="setEnd($event)"
            [formControlName]="field.dateRangeLastKey"
            [placeholder]="field.dateRangeLastLabel" readonly>
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
        <mat-hint align="start"><strong>{{field.hint}}</strong></mat-hint>
        @for (validation of field.validations; track validation) {
          <ng-container ngProjectAs="mat-error">
            @if (group.get(field.dateRangeFirstKey).hasError(validation.name)) {
              <mat-error>{{validation.message}}</mat-error>
            }
            @if (group.get(field.dateRangeLastKey).hasError(validation.name)) {
              <mat-error>{{validation.message}}</mat-error>
            }
          </ng-container>
        }
      </mat-form-field>
    }
    `,
    // host: {'class': 'col-md-6'},
    styles: [],
    standalone: false
})
export class DateRangeComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  visible = true;
  startDateValue: any;
  endDateValue: any;
  // @HostBinding('class') rowClass = 'col-md-6';
  constructor() {
  }
  ngOnInit() {
  }

  setStart($event: any) {
    this.startDateValue = $event;
  }
  setEnd($event: any) {
    this.endDateValue = $event;
  }
}
